import type { ActionsOfCreators, FeatureHandler } from '../helpers';

import { sleep } from './sleep';
import { wake } from './wake';
import { asleep } from './asleep';
import { awake } from './awake';
import { reload } from './reload';
import { statusPoll } from './statusPoll';
import { wakeByUser } from './wakeByUser';

export const inputActions = [
  sleep,
  wake,
  asleep,
  awake,
  reload,
  statusPoll,
  wakeByUser,
];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
